<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

const emit = defineEmits(['funnel-filter-selection']);

const { t } = useI18n();
const store = useStore();

// Buscar funis do store
const funnels = computed(() => store.getters['funnel/getFunnels'] || []);

// Opção padrão "Todos os Funis"
const defaultOption = {
  id: 'all',
  name: 'Todos os Funis',
  translationKey: 'REPORT.FUNNEL_FILTER.ALL_FUNNELS',
};

// Combinar opção padrão com funis disponíveis
const options = computed(() => [
  defaultOption,
  ...funnels.value.map(funnel => ({
    id: funnel.id,
    name: funnel.name,
    translationKey: null,
  })),
]);

const selectedId = ref('all');

const selectedOption = computed({
  get() {
    return options.value.find(o => o.id === selectedId.value) || defaultOption;
  },
  set(val) {
    selectedId.value = val.id;
  },
});

const updateFunnel = funnel => {
  selectedOption.value = funnel;
  emit('funnel-filter-selection', funnel);
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedOption"
      class="no-margin"
      track-by="id"
      label="name"
      :placeholder="'Selecionar Funil'"
      selected-label
      :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
      deselect-label=""
      :options="options"
      :searchable="false"
      :allow-empty="false"
      @select="updateFunnel"
    />
  </div>
</template>
